<template>
    <a-card>
        
        <h3 style="text-align: center;margin:20px 0 40px">项目负责人</h3>
        <a-descriptions v-for="(item,key) in form" style="margin-bottom:10px" :key="key" size="middle" :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }" bordered={true}>
            <a-descriptions-item label="姓名" name="name">{{item.name}}</a-descriptions-item>
            <a-descriptions-item label="性别" name="sex">
                <span v-if='item.sex==0'>男</span>
                <span v-if='item.sex==1'>女</span>
            </a-descriptions-item>
            <a-descriptions-item label="出生日期" name="birth">{{item.birth}}</a-descriptions-item>
            <a-descriptions-item label="政治面貌" name="politicalOutlook">
				<dict-render :dict-obj="dictObjs['politicalOutlook']" :text="item.politicalOutlook" v-if="item.politicalOutlook"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="身份证号" name="idcard">{{item.idcard}}</a-descriptions-item>
            <a-descriptions-item label="职务" name="duties">{{item.duties}}</a-descriptions-item>
            <a-descriptions-item label="籍贯" name="nativePlace">{{item.nativePlace}}</a-descriptions-item>
            <a-descriptions-item label="民族" name="nation">{{item.nation}}</a-descriptions-item>
            <a-descriptions-item label="工作单位" name="workUnit">{{item.workUnit}}</a-descriptions-item>
            <a-descriptions-item label="技术职称" name="technicalTitle">{{item.technicalTitle}}</a-descriptions-item>
            <a-descriptions-item label="学术职称" name="academicTitle">{{item.academicTitle}}</a-descriptions-item>
            <a-descriptions-item label="学位（最高学历学位）" name="academicDegree">
				<dict-render :dict-obj="dictObjs['education_background']" :text="item.academicDegree" v-if="item.academicDegree"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="毕业学校" name="graduationSchool">{{item.graduationSchool}}</a-descriptions-item>
            <a-descriptions-item label="毕业年份" name="graduateDate">{{item.graduateDate}}</a-descriptions-item>
            <a-descriptions-item label="专业" name="speciality">{{item.speciality}}</a-descriptions-item>
            <a-descriptions-item label="现从事专业" name="nowSpeciality">{{item.nowSpeciality}}</a-descriptions-item>
            <a-descriptions-item label="通讯地址" name="mailAddress">{{item.mailAddress}}</a-descriptions-item>
            <a-descriptions-item label="邮编" name="postalCode">{{item.postalCode}}</a-descriptions-item>
            <a-descriptions-item label="联系电话" name="telephone">{{item.telephone}}</a-descriptions-item>
            <a-descriptions-item label="手机号" name="phone">{{item.phone}}</a-descriptions-item>
            <a-descriptions-item label="邮箱" name="email">{{item.email}}</a-descriptions-item>
            <a-descriptions-item label="传真" name="fax">{{item.fax}}</a-descriptions-item>
            <a-descriptions-item :span="2" label="成就（相关研究基础和成果，主要论文或研究成果）" name="achievements">{{item.achievements}}</a-descriptions-item>
            <a-descriptions-item :span="2" label="概述（负责人情况概述）" name="overview">{{item.overview}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>

    import { projectLeader } from "@/api/TechnologieprojekteApply";
    import {
        dictMixin,
        formMixin
    } from "@/mixins";
    import DictRender from "@/components/other/DictRender";
    export default {
        name: "项目负责人",
        mixins: [
        dictMixin,formMixin],
        components: {
            DictRender
        },
        data() {
            return {
                options: null,
                form:{
                },
                dictNames: "leaderType,education_background,politicalOutlook",
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectLeader.selectList,
                    params: {
                        projectId: this.$route.query.projectId
                     }
                }).then((res) => {
                    this.form = res
                });
            }
        }

    }
</script>
